import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

interface TrackingInputProps {
  onTrack: (trackingNumber: string) => void;
}

const TrackingInput = ({ onTrack }: TrackingInputProps) => {
  const [searchParams] = useSearchParams();
  const [input, setInput] = useState('');

  // Pré-remplir le champ si ?track= est dans l'URL
  useEffect(() => {
    const trackParam = searchParams.get('track');
    if (trackParam && trackParam.trim()) {
      setInput(trackParam.trim());
    }
  }, [searchParams]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (input.trim()) {
      onTrack(input.trim());
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-5 sm:p-8 mb-6">
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1 relative">
          <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-[#0066CC] text-xl"></i>
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Ex : TV1234567890"
            className="w-full h-14 pl-12 pr-4 text-sm border-2 border-gray-200 rounded-xl focus:border-[#0066CC] focus:outline-none focus:ring-4 focus:ring-[#0066CC]/10 transition-all"
          />
        </div>
        <button
          type="submit"
          className="h-14 px-8 bg-[#00CC88] text-white font-semibold rounded-xl hover:bg-[#00CC88]/90 transition-all flex items-center justify-center whitespace-nowrap cursor-pointer gap-2"
        >
          <i className="ri-search-line"></i>
          Suivre
        </button>
      </form>
      <div className="flex flex-wrap gap-2 mt-4">
        <div className="px-3 py-1.5 bg-blue-50 text-[#0066CC] rounded-lg text-xs font-medium flex items-center gap-1.5">
          <i className="ri-information-line"></i>
          Entrez votre numéro de suivi unique pour voir l'état de votre envoi
        </div>
      </div>
    </div>
  );
};

export default TrackingInput;
